import React from "react";
import { Icon } from "@shared/components";
import "./index.scss";
import classnames from "classnames";
import { actions } from "@shared/store";
import { MODAL_TYPES } from "@shared/constants";
import { useDispatch } from "react-redux";
import { ModalSize } from "@shared/interfaces";

interface Props {
  list: string[];
  preview?: boolean;
  onRemove?: (index: number) => void;
}

export const Images = ({ list, preview, onRemove }: Props) => {
  const dispatch = useDispatch();

  if (!list.length) return null;

  const openPreview = (src: string) => {
    if (preview) {
      dispatch(
        actions.showModal({
          type: MODAL_TYPES.IMAGE_PREVIEW,
          closeIcon: true,
          size: ModalSize.XLG,
          props: {
            data: { src },
          },
        }),
      );
    }
  };

  return (
    <div className="images">
      <div className="images-scrollable">
        {list.map((src, ind) => (
          <div key={ind}>
            {!!onRemove && (
              <div className="close-btn" onClick={() => onRemove(ind)}>
                <Icon type="close" />
              </div>
            )}

            <div className={classnames("image-wrapper", { preview })} onClick={() => openPreview(src)}>
              <img src={src} alt={`img-${ind + 1}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
